import { openDb } from 'idb';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function createIdbStorage(definedOptions) {
  if (definedOptions === void 0) {
    definedOptions = {};
  }
  /** @var {Object} */


  var options = _extends({
    /** Database name */
    name: 'keyval-store',

    /** Store name */
    storeName: 'keyval',

    /** Database version */
    version: 1,

    /** Upgrade callback. Useful when for example switching storeName */
    upgradeCallback: function upgradeCallback(upgradeDb) {
      return upgradeDb.createObjectStore(options.storeName);
    }
  }, definedOptions);
  /** @var {Promise} */


  var dbPromise = openDb(options.name, options.version, options.upgradeCallback);
  return {
    /**
     * Get
     * @param {string} key
     * @return {Promise}
     */
    getItem: function getItem(key) {
      try {
        return Promise.resolve(dbPromise).then(function (db) {
          var tx = db.transaction(options.storeName);
          return tx.objectStore(options.storeName).get(key);
        });
      } catch (e) {
        return Promise.reject(e);
      }
    },

    /**
     * Set
     * @param {string} key
     * @param {string | number | IDBKeyRange | Date | ArrayBufferView | ArrayBuffer | IDBArrayKey | undefined} item
     * @return {Promise}
     */
    setItem: function setItem(key, item) {
      try {
        return Promise.resolve(dbPromise).then(function (db) {
          var tx = db.transaction(options.storeName, 'readwrite');
          tx.objectStore(options.storeName).put(item, key);
          return tx.complete;
        });
      } catch (e) {
        return Promise.reject(e);
      }
    },

    /**
     * Remove
     * @param {string} key
     * @return {Promise}
     */
    removeItem: function removeItem(key) {
      try {
        return Promise.resolve(dbPromise).then(function (db) {
          var tx = db.transaction(options.storeName, 'readwrite');
          tx.objectStore(options.storeName)["delete"](key);
          return tx.complete;
        });
      } catch (e) {
        return Promise.reject(e);
      }
    },

    /**
     * Get all keys
     * @return {Promise}
     */
    getAllKeys: function getAllKeys() {
      try {
        return Promise.resolve(dbPromise).then(function (db) {
          var tx = db.transaction(options.storeName);
          return tx.objectStore(options.storeName).getAllKeys();
        });
      } catch (e) {
        return Promise.reject(e);
      }
    },

    /**
     * Get all data
     * @return {Promise}
     */
    getAll: function getAll() {
      try {
        return Promise.resolve(dbPromise).then(function (db) {
          var tx = db.transaction(options.storeName, 'readwrite');
          return tx.objectStore(options.storeName).getAll();
        });
      } catch (e) {
        return Promise.reject(e);
      }
    },

    /**
     * Clear storage
     * @return {Promise}
     */
    clear: function clear() {
      try {
        return Promise.resolve(dbPromise).then(function (db) {
          var tx = db.transaction(options.storeName, 'readwrite');
          tx.objectStore(options.storeName).clear();
          return tx.complete;
        });
      } catch (e) {
        return Promise.reject(e);
      }
    }
  };
}

export default createIdbStorage;